'use client';

import { useEffect, useState } from 'react';

const COARSE_POINTER_QUERY = '(hover: none) and (pointer: coarse)';

/** True on touch-primary devices (phones/tablets). Used to tune AntD virtual lists for mobile scroll. */
export default function useCoarsePointer() {
    const [coarsePointer, setCoarsePointer] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(COARSE_POINTER_QUERY);
        const update = () => setCoarsePointer(media.matches);
        update();
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, []);

    return coarsePointer;
}
